<!-- here is other code snippets from the file -->
<div class="container">
  <div>
    <button mat-flat-button color="primary" (click)="goBack()">
      <i class="fa fa-arrow-left"></i> Back to Courses
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
      <p>Loading course details...</p>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <div class="error-message">
      <i class="fa fa-exclamation-triangle fa-2x"></i>
      <h3>Error</h3>
      <p>{{ error }}</p>

    </div>
  </div>

  <!-- Course Details -->
  <div *ngIf="course && !loading && !error" class="course-detail-container">
    <!-- Course Header -->
    <div class="course-container">
      <div class="course-header">
        <div class="course-title">
          <h1>{{ course.name }}</h1>
          <div class="course-code">{{ course.code }}</div>
        </div>
        <!-- Triangle Arrow moved here -->
        <div class="triangle-container" (click)="toggleCourseInfo()">
          <div class="triangle-arrow" [class.collapsed]="courseInfoCollapsed"></div>
        </div>
      </div>

      <!-- Removed the separate collapsible header since we moved the toggle to the course header -->

      <div class="collapsible-content" [class.collapsed]="courseInfoCollapsed">
        <div class="course-info-grid">
          <div class="info-box">
            <h4><i class="fa fa-tag icon-with-space"></i>PROVIDER</h4>
            <p>{{ course.provider || 'Microsoft' }}</p>
          </div>
          <div class="info-box">
            <h4><i class="fa fa-flask"></i>TOTAL LABS</h4>
            <p>{{ getLabsCount() }} Labs</p>
          </div>
          <div class="info-box">
            <h4><i class="fa fa-clock"></i>TOTAL DURATION</h4>
            <p>{{ getTotalDuration() }} Hours</p>
          </div>
          <div class="info-box">
            <h4><i class="fa fa-calendar" aria-hidden="true"></i>CREATED ON</h4>
            <p>{{ course.createdOn | date:'mediumDate' }}</p>
          </div>
        </div>

        <div class="course-description">
          <p> <i class="fa fa-file-text"></i> {{ course.description || 'Master building RESTful Web APIs with ASP.NET
            Core, Entity Framework Core, and
            SQL Server. Learn authentication, authorization, and best practices for modern web API development.' }}</p>
        </div>

        <h5><i class="fa fa-desktop"></i>VM Image Configuration</h5>
        &nbsp;
        <div class="vm-grid">

          <div class="vm-config-section">
            <h4><i class="fa fa-cloud"></i>Cloud Provider</h4>
            <div>
              <p><strong>Provider:</strong> {{ course.vmImage.cloudProviderData.provider || 'Azure' }}</p>
              <p><strong>Region:</strong> {{ course.vmImage.cloudProviderData.region || 'East US' }}</p>
              <p><strong>Size:</strong> {{ course.vmImage.cloudProviderData.size || 'Standard_D2s_v3' }}</p>
              <p><strong>Storage:</strong> {{ course.vmImage.cloudProviderData.storage || 'Standard_LRS' }}</p>
            </div>
          </div>

          <div class="vm-config-section">
            <h4><i class="fa fa-microchip"></i>Operating System</h4>
            <div>
              <p><strong>OS:</strong> {{ course.vmImage.softwareData.os || 'Windows 11' }}</p>
              <p><strong>Version:</strong> {{ 'Windows 11 Pro' }}</p>
            </div>
          </div>

          <div class="vm-config-section">
            <h4><i class="fa fa-cubes"></i>Software & Tools</h4>
            <div class="tools-container">
              <span *ngFor="let tool of softwareTools" class="tool-tag" [class.net]="tool.includes('.NET')"
                [class.sql]="tool.includes('SQL')"
                [class.vs]="tool.includes('Visual Studio') || tool.includes('VS Code')">
                {{ tool }}
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Course Labs Section -->
    <div class="course-labs">
      <h2>Course Labs</h2>
      <p>Hands-on exercises and practical learning modules</p>

      <ul class="tabs">
        <li [class.active]="selectedLab === i" *ngFor="let lab of course.labs; let i = index" (click)="selectedLab = i">
          <i class="fa fa-flask"></i> Lab {{ i + 1 }} - {{ lab.code }}
        </li>
      </ul>

      <div class="lab-details" *ngIf="course.labs && course.labs.length > 0">
        <h3><i class="fa fa-book-open"></i> {{ course.labs[selectedLab].name }}</h3>

        <div *ngFor="let content of course.labs[selectedLab].labContents; let i = index" class="content-item">
          <p>{{content}}</p><br>
        </div>
        <a href="{{ course.labs[selectedLab].labContentsUrl }}" target="_blank">
          {{ course.labs[selectedLab].labContentsUrl }}
        </a>
        <div>
          <iframe src="https://example.com" style="border: 2px solid #333;" width="100%" height="500px"></iframe>
        </div>
      </div>
    </div>